module.exports = __webpack_public_path__ + "static/media/s_big_03.250a39cf.png";